/**
 * Servicio que conecta con la API las inspecciones de las incidencias
 */
OrdenRestService.$inject = ['$resource'];
export default function OrdenRestService($resource) {
    var urlBase = Sigo.var.path + '/api/v1' + '/ordenes' + '/:ordenId';

    return $resource(urlBase, {
            ordenId: '@ordenId'
        }, {
            // 'edit': {method: 'GET', url: urlBase + '/edit'},
            'update': {method: 'PUT'}
        }
    );
}